import {
  PokemonType,
  SkillData,
  SkillType,
  SkillRangeType,
  SkillEvent_Vfx,
  SkillEvent_Shield,
} from "types/battle-engine/battle";

// Shield Skills
export const PROTECT: SkillData = {
  id: "protect",
  name: "Protect",
  description: "Creates a protective shield around yourself.",
  power: 0,
  pokemon_type: PokemonType.NORMAL,
  types: [SkillType.SHIELD],
  cooldown_ticks: 50,
  mana_cost: 5,
  range: {
    type: SkillRangeType.SELF,
    value: 0,
  },
  on_hit: [],
  on_cast: [
    {
      __typename: "Vfx",
      duration_ticks: 35,
      target: {
        type: "self",
        id: 0,
      },
      status_effects: [],
      starting_tick: 0,
      sprite_path: "/assets/spells/self/shield-1-blue.png",
      blocks_event_pipeline: false,
      loops: 2,
      speed: 0.8,
      ping_pong: true,
    } as SkillEvent_Vfx,
    {
      __typename: "Shield",
      duration_ticks: 20,
      target: {
        type: "self",
        id: 0,
      },
      status_effects: [],
      starting_tick: 0,
      shield_amount: 35,
      shield_duration_ticks: 65,
      blocks_event_pipeline: true,
    } as SkillEvent_Shield,
  ],
};